import React from 'react';
import { Link, Outlet, NavLink } from 'react-router-dom';

export default function App(): React.JSX.Element {
  return (
    <div style={{ fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif', margin: '0 auto', maxWidth: 1200, padding: 16 }}>
      <header style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
        <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}><h1 style={{ margin: 0 }}>FPL Insights</h1></Link>
        <nav style={{ display: 'flex', gap: 16 }}>
          <NavLink to="/" end>Dashboard</NavLink>
          <NavLink to="/players">Players</NavLink>
        </nav>
      </header>
      <Outlet />
      <footer style={{ marginTop: 32, color: '#666' }}>
        <small>Data via FPL and Elo Insights — cached at the edge.</small>
      </footer>
    </div>
  );
}



